export const msalConfig = {
  auth: {
    clientId: '4d9d1b08-eeaf-4669-8981-73236f55340e',
    authority: 'https://login.microsoftonline.com/25af836b-f6fd-4458-b748-60e72de7efd9',
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

export const graphRequest = {
    scopes: ['User.Read']
};

// For your API
export const apiRequest = {
    scopes: ['api://4d9d1b08-eeaf-4669-8981-73236f55340e/User.Read']
};

// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
};